<template>
    <div class="invest">
      <div class="banner">
        <el-image :src="require('../../assets/home/invest.png')" class="banner-img"></el-image>
      </div>
      <div class="tag">
          <div class="title">
            <div class="slogan">投资者关系</div>
            <div class="sloganen">INVESTOR RELATIONS</div>
          </div>
      </div>
      <div id="about-meau">
        <el-tabs v-model="activeName" @tab-click="investMenuSelect">
        <el-tab-pane v-for="item in menus" :key="item.id" :name="item.type" :label=" item.name">
           <span v-show="tag==1"> {{ item.name }}</span>
           </el-tab-pane>
        </el-tabs>
      </div>
        <div class="new-list" v-show="tag==1">
        <el-row v-for ="(notic, index) in noticeList" :key="index" class="xuxian" >
          <el-col :span="1"><div class=" dot"></div></el-col>
          <el-col :span="18"><div class="notice" @click="openNotice(notic.id)" >{{notic.title}}</div></el-col>
          <el-col :span="4" :offset="1"><div class="notice news-time">{{notic.creatDate.slice(0,10)}}</div></el-col>
        </el-row>
        </div>
        <div class="new-info" v-show="tag==2">
          <span class="new-info-title">{{noticinfo.title}}</span>
          <p class="ql-editor" v-html='noticinfo.content'></p>

        </div>
    </div>

</template>
<script>

import { getRequest } from "../../util/api";
import VueQuillEditor from 'vue-quill-editor'
// require styles 引入样式
import 'quill/dist/quill.core.css'
export default {
  data() {
    return {
      menus: [],
      noticeList:[],
      content: "",
      activeName: '',
       tag:1,
      noticinfo:"",
    };
  },
  mounted() {
    this.getMenuChildren();
    this.activeName=this.$route.query.id;
      if ('regular'==this.$route.query.id){
        this.getList(3)
        this.tag=1;
      }else{
        this.getList(4)
        this.tag=1;
      }
  },

  watch: {
    activeName(newVal) {
      this.$router.push({
        query: {id:`${this.activeName}`}
      })
    },
    '$route.query.id':function(newVal){
        this.activeName=newVal;
        if ('regular'==newVal){
        this.getList(3);
        this.tag=1;
      }else{
        this.getList(4);
        this.tag=1;

      }
    }
  },

  methods: {
     investMenuSelect(tab, event) {
         let that = this
          if ('regular'==tab.name){
          that.getList(3); 
          that.tag=1;
          }else{
          that.getList(4); 
          that.tag=1;
          }
    },
    getMenuChildren() {
      let that = this;
      let params = {
        pid: 5
      };
      getRequest("/menus/type", params).then(function(res) {
        if (res.data.meta.code == 1) {
          console.log("进来了hah");
          that.menus = res.data.data;
           that.activeName=res.data.data[0].type;
        }
      });
    },
      getList(key) {
      let origin = document.location.origin
      let that = this
      that.imageUrl='http://www.lensyn.com:8088/';
      let params = {
        type: key,
        keyWords: that.keyWords,
        pageStart: 0,
        pageSize: 1000
      }
      getRequest('/news/list', params).then(function(res) {
        if (res.data.meta.code === 1) {
          that.noticeList = res.data.data
        }
      })
    },
        openNotice(id){
      let that = this
      that.tag=2
       
      let params = {
        id: id
      }
       getRequest('/news/content', params).then(function(res) {
          
          that.noticinfo = res.data.data
        
       })
    }
  }
};
</script>
<style >
.dot {
		  width: 8px;
		  height: 8px;
		  border-radius: 100%;
		  background:  #D9D9D9;
      margin-top: 14px;
}
.notice {
  height: 30px;
  color: #0E2336;
  font-size: 20px;
  line-height: 30px;
  font-weight: 500;
  cursor: pointer;
}

.new-info{
  padding-bottom: 50px;
  padding-top: 25px;
  height: auto;
  width: 80%;
  margin: auto; 
}

/* .new-info img{
width: 100%;
height: 100%;
} */

.new-info-title{
  text-align: center;
  display:block;
  font-weight:500;
  font-size: 24px;
  line-height: 36px;
}
.invest{
  width: 99%;
}
</style>
<style src="../../css/banner.css"></style>


// WEBPACK FOOTER //
// src/components/content/Invest.vue